import { brand } from '../config/brand'

/**
 * onDark  → avatar (cerchio bianco) su sfondi verdi/scuri
 * onLight → logo nero su pannello chiaro
 */
export function BrandMark({
  variant = 'onDark',
  size = 'md',
  className = '',
  alt,
}) {
  if (variant === 'onLight') {
    const sizeClass =
      size === 'lg' ? 'brand-logo-lg' : size === 'sm' ? 'brand-logo-sm' : 'brand-logo-md'

    return (
      <span className={`brand-logo-wrap ${sizeClass} ${className}`.trim()}>
        <img
          src={brand.logo}
          alt={alt ?? brand.siteName}
          className="brand-logo-img"
          width={size === 'lg' ? 200 : size === 'sm' ? 36 : 48}
          height={size === 'lg' ? 175 : size === 'sm' ? 32 : 42}
        />
      </span>
    )
  }

  const px = size === 'lg' ? 120 : size === 'sm' ? 40 : 56

  const isLcp = size === 'lg'

  return (
    <img
      src={brand.avatar}
      alt={alt ?? brand.siteName}
      className={`brand-mark-avatar brand-mark-${size} ${className}`.trim()}
      width={px}
      height={px}
      decoding="async"
      {...(isLcp ? { fetchPriority: 'high' } : { loading: 'lazy' })}
    />
  )
}
